import { createContext, FC, ReactNode, useContext, useEffect, useState } from 'react';
import { AnnouncementType } from '../types';
import useFetchWithAuth from '../../../../CommonHooks/useFetchWithAuth';
import { useMainContainerProvider } from '../../../../mainContainerProvider';
import { noticeBaseUrl } from '../../../../baseUrl';
import { errorToast } from '../../../../CommonComponent/toast';

interface AnnouncementContextType {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  announcementList: AnnouncementType[];
  setAnnouncementList: React.Dispatch<React.SetStateAction<AnnouncementType[]>>;
  setCreateDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setEditDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  createDialogOpen: boolean;
  editDialogOpen: boolean;
  handleGetAnnouncementList: () => Promise<void>;
}

const initialAnnouncementList: AnnouncementContextType = {
  createDialogOpen: false,
  editDialogOpen: false,
  isLoading: false,
  announcementList: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setAnnouncementList: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  handleGetAnnouncementList: async () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsLoading: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCreateDialogOpen: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setEditDialogOpen: () => {},
};

const AnnouncementContext = createContext<AnnouncementContextType>(initialAnnouncementList);
const AnnouncementProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [announcementList, setAnnouncementList] = useState<AnnouncementType[]>([]);
  const [createDialogOpen, setCreateDialogOpen] = useState<boolean>(false);
  const [editDialogOpen, setEditDialogOpen] = useState<boolean>(false);
  const { uid, instituteId } = useMainContainerProvider();
  const { fetchWithAuth } = useFetchWithAuth();

  const handleGetAnnouncementList = async () => {
    setIsLoading(true);
    const { error, data } = await fetchWithAuth(
      `notice-list/?uid=${uid}&noticeStatus=delivered&instituteId=${instituteId}&type=announcement`,
      {},
      noticeBaseUrl
    );
    setIsLoading(false);
    if (error) {
      errorToast(error);
    } else {
      setAnnouncementList(data);
    }
  };

  useEffect(() => {
    handleGetAnnouncementList();
    // eslint-disable-next-line
  }, []);
  return (
    <AnnouncementContext.Provider
      value={{
        isLoading,
        setIsLoading,
        announcementList,
        setAnnouncementList,
        setCreateDialogOpen,
        setEditDialogOpen,
        createDialogOpen,
        editDialogOpen,
        handleGetAnnouncementList,
      }}
    >
      {children}
    </AnnouncementContext.Provider>
  );
};

export default AnnouncementProvider;

export const useAnnouncementProvider = () => useContext(AnnouncementContext);
